// Menu Item 1060 / NavBar 1060 — KUK site nav (kukonline.ac.in `organisms/Header`).
// White bar: crest + wordmark left, nav links with dropdowns, a brand-filled
// Sign Up CTA right. The current page's link carries a grey pill rather than a
// colour change, which is what separates it from NavBar 1047.
//
// THREE LEVELS, as in 1047: a top-level item (Programmes) holds programmes, and
// a programme holds its specialisations, which expand inline inside the
// dropdown. `menu_item.parent_id` is self-referential, so the extra level needs
// no schema change — add the specialisation with its programme as Parent Menu.
//
// TWO LOGOS. `logo_icon` is the crest (shown at every width) and
// `mobile_logo_icon` is the wordmark beside it (shown below 768px and from
// 1080px up, hidden in between, where the nav needs the room). That is v1's
// arrangement, mapped onto the columns the nav_bar table already has.
//
// Both default to the files already shipped in `webapp/public/icons`
// (`kuk-logo.png` 31x36, `kuk-university-print.png` 540x156) — byte-identical
// to v1's `icons/logo.png` and `icons/university_print.png`, which is what the
// live site serves. They are LOCAL paths, not bucket URLs: kukonline.ac.in
// renders them from its own `public/`, and the asset bucket has no copy of the
// crest at all. An editor can still upload replacements over them.
//
// Reuses the shared nav_bar / menu_item columns — no new columns.

export const NAVBAR_1060_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    logo_icon: "/icons/kuk-logo.png",
    logo_icon_alt: "KUK University",
    mobile_logo_icon: "/icons/kuk-university-print.png",
    mobile_logo_icon_alt: "KUK University",
    // Bar
    background_color: "#FFFFFF",
    nav_text_color: "#1B1B1B",
    active_menu_color: "#EAECF0",
    border_color: "#EAECF0",
    mobile_menu_text_color: "#1B1B1B",
    show_bar_shadow: true,
    // Dropdown
    dropdown_bg_color: "#FFFFFF",
    dropdown_text_color: "#1B1B1B",
    show_dropdown_icons: false,
    // CTA (Sign Up)
    cta3_enabled: true,
    cta3_label: "Sign Up",
    cta3_href: "",
    cta3_bg_color: "#9F1C33",
    cta3_text_color: "#FFFFFF",
    // Mobile chrome
    hamburger_icon: "",
    hamburger_icon_alt: "",
    mobile_cancel_icon: "",
    mobile_cancel_icon_alt: "",
    sticky_to_top: true,
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    // --- Logo ---
    { fieldName: "logo_icon", label: "Crest", value: "/icons/kuk-logo.png", valueType: "string", filedType: "FILE", placeholder: "Shown at every width", description: "Defaults to the bundled /icons/kuk-logo.png.", required: true, defaultValue: "/icons/kuk-logo.png" },
    { fieldName: "logo_icon_alt", label: "Crest Alt Text", value: "KUK University", valueType: "string", filedType: "INPUT", placeholder: "KUK University", required: false, defaultValue: "KUK University" },
    { fieldName: "mobile_logo_icon", label: "Wordmark", value: "/icons/kuk-university-print.png", valueType: "string", filedType: "FILE", placeholder: "Shown below 768px and from 1080px up", description: "Defaults to the bundled /icons/kuk-university-print.png.", required: false, defaultValue: "/icons/kuk-university-print.png" },
    { fieldName: "mobile_logo_icon_alt", label: "Wordmark Alt Text", value: "KUK University", valueType: "string", filedType: "INPUT", placeholder: "KUK University", required: false, defaultValue: "KUK University" },

    // --- Bar colours ---
    { fieldName: "background_color", label: "Bar Background Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "nav_text_color", label: "Menu Text Color", value: "#1B1B1B", valueType: "string", filedType: "COLOR", placeholder: "#1B1B1B", required: false, defaultValue: "#1B1B1B" },
    { fieldName: "active_menu_color", label: "Active / Open Link Pill", value: "#EAECF0", valueType: "string", filedType: "COLOR", placeholder: "#EAECF0", description: "The reference tints the current page's link rather than recolouring it.", required: false, defaultValue: "#EAECF0" },
    { fieldName: "border_color", label: "Border / Divider Color", value: "#EAECF0", valueType: "string", filedType: "COLOR", placeholder: "#EAECF0", required: false, defaultValue: "#EAECF0" },
    { fieldName: "mobile_menu_text_color", label: "Menu Text Color (Mobile drawer)", value: "#1B1B1B", valueType: "string", filedType: "COLOR", placeholder: "#1B1B1B", required: false, defaultValue: "#1B1B1B" },
    { fieldName: "show_bar_shadow", label: "Show Bar Shadow", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Drop shadow under the bar", defaultValue: true },

    // --- Dropdown (nested menu items) ---
    { fieldName: "dropdown_bg_color", label: "Dropdown BG Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "dropdown_text_color", label: "Dropdown Text Color", value: "#1B1B1B", valueType: "string", filedType: "COLOR", placeholder: "#1B1B1B", required: false, defaultValue: "#1B1B1B" },
    { fieldName: "show_dropdown_icons", label: "Show Dropdown Icons", value: false, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show icons on dropdown items", defaultValue: false },

    // --- CTA (Sign Up) ---
    { fieldName: "cta3_enabled", label: "Show CTA Button", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable the CTA button", defaultValue: true },
    { fieldName: "cta3_label", label: "CTA Label", value: "Sign Up", valueType: "string", filedType: "INPUT", placeholder: "Sign Up", required: false, defaultValue: "Sign Up" },
    { fieldName: "cta3_href", label: "CTA Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "Leave empty to open the lead form popup", required: false, defaultValue: "" },
    { fieldName: "cta3_bg_color", label: "CTA Background", value: "#9F1C33", valueType: "string", filedType: "COLOR", placeholder: "#9F1C33", required: false, defaultValue: "#9F1C33" },
    { fieldName: "cta3_text_color", label: "CTA Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- Mobile chrome ---
    { fieldName: "hamburger_icon", label: "Hamburger Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload hamburger icon (optional)", required: false, defaultValue: "" },
    { fieldName: "hamburger_icon_alt", label: "Hamburger Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Menu", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon", label: "Mobile Close Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload close icon (optional)", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon_alt", label: "Mobile Close Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Close", required: false, defaultValue: "" },

    { fieldName: "sticky_to_top", label: "Stick to top on scroll", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Pin the nav while scrolling", defaultValue: true },
    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable widget", defaultValue: true },
  ],
};

export const MENU_ITEM_1060_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true,
    priority: 1,
    text_color: "",
    icon: "",
    icon_alt: "",
  },

  MENU_FIELDS_CONFIG: [
    { fieldName: "title", label: "Title", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter menu title (e.g., Programmes)", required: true, defaultValue: "" },
    { fieldName: "parent_id", label: "Parent Menu", value: null, valueType: "string", filedType: "SELECT", placeholder: "Select parent menu (pick a programme for a specialisation)", required: false, defaultValue: null, options: [] },
    { fieldName: "slug", label: "Slug", value: "", valueType: "string", filedType: "INPUT", placeholder: "Auto-generated from title", defaultValue: "" },
    { fieldName: "url", label: "URL", value: "", valueType: "string", filedType: "INPUT", placeholder: "/online-mba or https://… (optional)", required: false, defaultValue: "" },
    { fieldName: "priority", label: "Priority", value: 1, valueType: "number", filedType: "INPUT", placeholder: "Enter display priority", required: true, defaultValue: 1 },
    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable menu item", defaultValue: true },
    { fieldName: "text_color", label: "Text Color", value: "", valueType: "string", filedType: "COLOR", placeholder: "Leave empty to inherit the navbar colors", required: false, defaultValue: "" },
    { fieldName: "icon", label: "Dropdown Item Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload item icon (optional)", required: false, defaultValue: "" },
    { fieldName: "icon_alt", label: "Dropdown Item Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter icon alt text", required: false, defaultValue: "" },
  ],

  TREE_CONFIG: {
    treeTitle: "Menu Structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    itemDisplayFields: {
      primary: "title",
      secondary: "slug",
      statusField: "status",
      statusInactiveLabel: "Inactive",
      childrenField: "children",
    },

    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority",
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status",
    },

    parentFieldName: "parent_id",
    parentTopLevelValue: "null",
    parentTopLevelLabel: "-- Top Level --",

    formLabels: {
      addNew: "➕ Add New Menu Item",
      edit: "✏️ Edit Menu Item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id",
    childItemsFieldName: "menuItems",
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
    // KUK's bar carries six top-level links; leave headroom without letting the
    // row wrap.
    itemLimits: { max: 10 },
  },
};
